import ImgHandshake from "../assets/images/hand-shake-icon.png";
import ImgDeliveryTruck from "../assets/images/delivery-truck-icon.png";
import ImgServiceProvider from "../assets/images/service-provider-icon.png";
import ImgFuelPump from "../assets/images/fuel-pump-icon.png";
import ImgCloudData from "../assets/images/cloud-data-icon.png";
import ImgAtm from "../assets/images/atm-icon.png";
import ImgCalendar from "../assets/images/calendar-icon.png";
import ImgUTTS from "../assets/images/processor.png"
import ImgTTS from "../assets/images/tts-icon-1.png"

const steps = [
  {
    step: 1,
    img: ImgHandshake,
    title:
      "Satış temsilcimiz ile müşterimiz, Taşıt Tanıma Sistemi'ne dahil olma konusunda anlaşmaya varır ve ilgili sözleşme karşılıklı olarak onaylanır.",
  },
  {
    step: 2,
    img: ImgUTTS,
    title:
      "Aracınıza UTTS montajı yapılmamışsa, size en yakın Kit-Tak montaj noktasına giderek montajınızı gerçekleştirilir. 5 veya daha fazla araç için ise Kit-Tak ekibi, randevu ile bulunduğunuz yerde montaj yapar.",
  },
  {
    step: 3,
    img: ImgFuelPump,
    title:
      "İstasyondaki görevli, aracın depo kapağındaki UTTS birimi sayesinde aracı tanır ve uygun UTTS pompasına yönlendirir.",
  },
  {
    step: 4,
    img: ImgCloudData,
    title:
      "Yakıt alımı sırasında Taşıt Tanıma Ünitesi, pompa ile iletişim kurar. Yakıt tipi, miktarı ve dolum zamanı Shell'in merkezi sistemine kaydedilir ve bilgiler istasyona aktarılır.",
  },
  {
    step: 5,
    img: ImgAtm,
    title:
      "Dolum işlemi bittiğinde, makbuz otomatik olarak yazdırılır ve istasyon çalışanı tarafından sürücüye verilir. Sürücü, makbuzunu aldıktan sonra yoluna devam edebilir.",
  },
  {
    step: 6,
    img: ImgCalendar,
    title:
      "Sisteme dahil olan araçların yakıt harcamaları, her ayın 15'inde ve sonunda faturalandırılır. Faturalarınızı, firmanızın ödeme süreçlerine uygun şekilde kolayca ödeyebilirsiniz.",
  },
  {
    step: 7,
    img: ImgTTS,
    title:
      "Taşıt Tanıma Sistemi'ne dair tüm işlemlerinizi, internet erişimi olan her yerden kolayca gerçekleştirebilirsiniz.",
  },
];

export default steps;